define('models/WidgetLayoutModel',['underscore','LocalStorage','ObjectModel','app','models/WidgetInstanceCollection','WidgetInstanceModel'],function (_,LocalStorage,ObjectModel,app,WidgetInstanceCollection,WidgetInstanceModel) {
    //
    // Model WidgetLayoutFormat
    //
    var WidgetLayoutFormatModelPrototype = {
        
        name:'WidgetLayoutFormatModel',
        route:'apiWidgetLayoutFormatModel',
        idAttribute:'id_widget_layout',
        
        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            //
            if(!model.get(model.idAttribute)){
                model.attributes[model.idAttribute] = model.get('id');
            }
            var instances = model.instances = new WidgetInstanceCollection();
            _(model.get('instances')).each(function(instance){
                instances.models.push(app.getWidgetInstance(instance.id_widget_instance));
            });
        },
        getInstances:function(){
            return this.instances;
        }
    };

    var WidgetLayoutFormatModel = ObjectModel.extend(LocalStorage).extend(WidgetLayoutFormatModelPrototype);
    
    return WidgetLayoutFormatModel;
});
